import { Controller } from "@hotwired/stimulus"

// Polls the explanation_comparison turbo frame until all explanations are completed
export default class extends Controller {
  connect() {
    const frame = document.querySelector("turbo-frame#explanation_comparison")
    if (frame.querySelector(".is-hidden").dataset.poll == 'true') {
      setTimeout(() => this.reloadFrame(), 5000)
    }
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  reloadFrame() {
    const frame = document.querySelector("turbo-frame#explanation_comparison")
    frame.reload()
  }
}
